import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import type { ImportModel } from "../../domain/models/Import";
import { importQuery } from "../../services/payments/ImportQueryService";
import { queryKeys } from "@/utils/queryKeys";
const POLL_INTERVAL_MS = 4000;
const isTerminalStatus = (status?: ImportModel["status"]): boolean => status === "success" || status === "failed";
export const useImportStatus = importId => {
  const $ = _c(8);
  let t0;
  if ($[0] !== importId) {
    t0 = queryKeys.payments.import(importId ?? "none");
    $[0] = importId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = Boolean(importId);
  let t2;
  if ($[2] !== importId) {
    t2 = async () => {
      const response = await importQuery.search({
        search: {
          filters: [{
            field: "id",
            operator: "=",
            value: importId
          }],
          includes: [{
            relation: "user"
          }],
          limit: 10
        }
      });
      return response.data[0] ?? null;
    };
    $[2] = importId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = {
      queryKey: t0,
      enabled: t1,
      queryFn: t2,
      refetchInterval: _temp
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useQuery(t3);
};
function _temp(query) {
  return isTerminalStatus(query.state.data?.status) ? false : POLL_INTERVAL_MS;
}